import { CircularProgress } from "@mui/material"
import Mnemonic from "../../../Mnemonics.json";
import ContainerCard from "../../../components/Cards/ContainerCard"
import DataTable from "../../../components/Tables/DataTable"
import { GET_USER_TABLE_PREFERENCES } from "../../../graphql/userTablePreferences";
import useAuth from "../../../hooks/useAuth";
import { decodeUnicodeString } from "../../../utils/decodeUnicodeString";
import { Parse } from "../../../JSON.editor";
import { removeNullProps } from "../../../utils/removeNullProps";
import { useCallback, useEffect, useState } from "react";
import useQueryAuth from "../../../hooks/useQueryAuth";
import UTC2Local, { formatDateTimeToString } from "../../../UTC2Local";
import componentDisplay from "../../../componentDisplay";
import { useParams } from "react-router-dom";
import { GET_ALL_PROJECTS, GET_ALL_PROJECTS_DROPDOWN, GET_ALL_PROJECTS_STATUSES } from "../../../graphql/project";
import useLazyQueryAuth from "../../../hooks/useLazyQueryAuth";

const MyProjects = () => {

    const { storeUserGuid, storeUserTenant, userRoles } = useAuth();
    const [re, setRe] = useState(false);
    const [data, setData] = useState(null);
    const [defaultFilters, setDefaultFilters] = useState({});
    const [columns, setColumns] = useState([]);
    const [order, setOrder] = useState("");
    const [orderBy, setOrderBy] = useState("");
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [statusList, setStatusList] = useState([]);
    const [search, setSearch] = useState("");
    const { eID, tID, profileID } = useParams();
    const { manageUsers, isEntelligence, manageTimeEntry } = userRoles;

    
    const {
      data: statusesList,
      loading: statusLoading,
      tokenChange: statusWait,
    } = useQueryAuth(GET_ALL_PROJECTS_STATUSES, "GetProjectStatuses");
  
    useEffect(() => {
      if(statusesList) 
        setStatusList(statusesList?.GetProjectStatuses?.projectStatuses || []);
    }, [statusesList])
    
    const filtersObject = [
      {
        type: "text",
        label: "project.filters.label.title",
        name: "title",
      },
      {
        type: "text",
        label: "project.filters.label.description",
        name: "description",
      },
      {
        type: "text",
        label: "project.filters.label.company",
        name: "company",
      },
      {
        type: "text",
        label: "project.filters.label.externalRef",
        name: "externalReference",
      },
      {
        type: "text",
        label: "project.filters.label.companyRef",
        name: "companyReference",
      },
      {
        label: "project.list.filter.isOpen",
        name: "projectStatusesIDs",
        type: "multiple",
        getOptionLabel: (option) => (option ? option.description : ""),
        options: statusList,
        access: "projectStatusGuid",
        loading: statusLoading,
      },
    ];

    const {
      loading: getColumnsLoading,
      tokenChange: columnsWait,
      refetch,
    } = useQueryAuth(
      GET_USER_TABLE_PREFERENCES,
      "GetUserTablePreferences",
      {
        variables: {
          model: {
            table: Mnemonic.Tables.Projects,
            userID: storeUserGuid,
          },
        },
        skip: statusWait,
        isWait: true,
      },
      {
        onCompleted: (response) => {
          let col =
            response &&
            response.GetUserTablePreferences &&
            response.GetUserTablePreferences.columns
              ? response.GetUserTablePreferences.columns
              : null;
  
          if (col) {
            col = decodeUnicodeString(col);
  
            const parsed = JSON.parse(col, (key, value) =>
              Parse(key, value, UTC2Local, componentDisplay, null, null, null, formatDateTimeToString)
            );
  
            const cols = parsed.columns;
            const filteredColumns = cols.filter((c) => c.id == "Title"  || c.id == "Company"  || c.id == "Location" || c.id == "ExternalReference" || c.id == "CompanyReference");
  
                filteredColumns.map(c => {
                  c = removeNullProps(c);
                  return c;
                })
                setColumns(filteredColumns);

  
            
            // if (parsed.columns) setColumns(parsed.columns);
  
            if (parsed.defaultSort) setOrderBy(parsed.defaultSort);
  
            if (parsed.defaultSortDirection)
              setOrder(parsed.defaultSortDirection);
          }
        },
      }
    );

  const { mfunction: getAllProjects, loading , refetch : refetchData} = useLazyQueryAuth(
    GET_ALL_PROJECTS,
    "GetAllProjects"
  );

  const fetchTableData = useCallback(
    (
      page = 0,
      pageSize = 0,
      order = "",
      orderBy = "",
      search = "",
      filters = null
    ) => {
      getAllProjects(
        {
          variables: {
            model: {
              enableFilters: true,
              keys: {
                page: page + 1,
                pageSize: pageSize,
              },
              orderColumn: orderBy,
              orderDirection: order,
              keyWord: search,
              userID: storeUserGuid,
              tenantID: storeUserTenant,
              filters: filters,
              employeeID: eID,
            },
          },
        },
        (response) => {
          setData(response);
        }
      );
    },
    []
  );

  useEffect(() => {
    if ( !columnsWait)
      fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
  }, [columnsWait, fetchTableData, re, defaultFilters]);

  const rows =
  data &&
  data.GetAllProjects &&
  data.GetAllProjects.projectsList &&
  data.GetAllProjects.projectsList.projects
    ? data.GetAllProjects.projectsList.projects
    : [];
const numberOfRecords =
  data &&
  data.GetAllProjects &&
  data.GetAllProjects.projectsList &&
  data.GetAllProjects.projectsList.totalNumberOfRecords
    ? data.GetAllProjects.projectsList.totalNumberOfRecords
    : 0;

    const pagination = {
      rows,
      columns,
      order,
      setOrder,
      orderBy,
      setOrderBy,
      selected,
      setSelected,
      defaultFilters,
      setDefaultFilters,
      search,
      setSearch,
      setPage,
      setRowsPerPage,
      numberRecords: numberOfRecords,
      page,
      // hideEditColumns: fromResource,
      rowsPerPage,
      fetchTableData,
      loading: loading || columnsWait,
      searchText: "project.list.search.label",
      refetch,
      tableMnemonic: Mnemonic.Tables.Projects,
      filtersObject,
      readOnly: manageTimeEntry !== "M",
    };

   


    return(
        <div>
        {getColumnsLoading ? (
            <ContainerCard
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <CircularProgress />
            </ContainerCard>
          ) : (
            <DataTable
              {...pagination}
              identifier="myProjectsGuid"
              heightClassName={"tableHeightProjectsEmployees"}
              fromEmployee
              hasCheckbox={eID ? true : false}
            />
          )}
          </div>
    )
}

export default MyProjects